import React, { PropTypes } from 'react';
import { NitroParagraph } from 'nitro-components';
import styled from 'styled-components';

const StatusNote = styled.div`
  padding: 10px 12px;
  background: ${props => props.theme.color.white};
  border-radius: 2px;
  margin-top: 10px;
  border: 1px solid ${props => props.theme.color.border};
`;

const QuoteApproverNote = ({ note }) => {
  return (
    <StatusNote>
      <NitroParagraph size="4" noMargin>{note}</NitroParagraph>
    </StatusNote>
  );
};

QuoteApproverNote.propTypes = {
  note: PropTypes.string
};

export default QuoteApproverNote;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteApproverNote.js